<template>
  <div class="footer-container">
    <div class="button-container">
      <slot name="button">
        <el-button size="small"
                   type="primary"
                   v-if="showConfirm"
                   @click="handleConfirm"
                   :loading="confirmLoading">
          {{ buttonList[0].label }}
        </el-button>
      </slot>
      <el-button size="small"
                 type="primary" plain
                 v-if="showCancel"
                 @click="handleBack"
                 :loading="backLoading">
        {{ buttonList[1].label }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {}
  },
  props: {
    showConfirm: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    cancelConfirm: {// 取消，返回时候是否需要确认对话框
      type: Boolean,
      default: false,
    },
    buttonList: {
      type: Array,
      default: () => {
        return [
          {label: '保存', type: "primary"},
          {label: '返回', type: ""}
        ]
      }
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    backLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /** 返回 */
    handleBack() {
      if (!this.cancelConfirm) {
        this.$router.back();
        return;
      }
      let title = '是否要返回？'
      let content = '返回后您填写的内容将不会保存，建议先保存。'
      let that = this
      that.$modal.confirm(content, title, {confirmButtonText: '保存', cancelButtonText: '不保存'}).then(() => {
        this.$emit('handleConfirm', {}, () => {
          // that.$router.go(-1);
          that.$router.back();
        })
      }).catch(() => {
        // 取消
        that.$router.back();
      })
    },
    /** 业务处理 */
    handleConfirm() {
      this.$emit('handleConfirm');
    },
  }
}
</script>

<style lang="less" scoped>

.footer-container {
  width: 100%;
  height: 50px;
  padding: 5px 24px;
  border-top: 1px solid rgb(235, 237, 240);
  background-color: #FFFFFF;
  display: flex;
  justify-content: flex-end;

  .button-container {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
